var references = (function() {
  var $refEl = $('.references')
  var $moreBut = $refEl.find('div.show-more')
  var $allBut = $refEl.find('div.show-all')
  var $noneFound = $refEl.find('.none-found')
  var $updateClickers = $('.ref-updater')
  var $loadImage = $refEl.find('.loader')
  var $columns = $refEl.find('.column')
  var $ref1 = $refEl.find('.first')
  var $ref2 = $ref1.siblings('.second')
  var $ref3 = $ref2.siblings('.third')
  var $filtersEl = $('.ref-filters')
  var $filters = $filtersEl.find('.filter')

  var limit = 5;
  let skip = 0
  const step = 5
  var processing = false
  var requestDelay = 400

  $('.filter-section').find('.filter').on('click', function() {
    $(this).toggleClass('active')
  })


  $updateClickers.click(function(e) {
    // if ($(this).hasClass('disabled')) {
      // e.preventDefault()
      // return
    // }
    process(e)
  })
  $moreBut.click(function(e) {
    limit += 99
    e.stopImmediatePropagation()
    process(e)
    if ($(this).data('onetime')) {
      $(this).css('opacity', 0)
      $(this).css('pointer-events', 'none')
    }
  })
  $allBut.click(function(e) {
    limit = 999999
    $filters.filter('.active').each(function() {
      $(this).removeClass('active')
    })
    var services = $('input[name="services"]')
    var refs = services.filter('[value="references"]').prop('checked', true)
    var studies = services.filter('[value="studies"]').prop('checked', true)
    e.stopImmediatePropagation()
    process(e)
    if ($(this).data('onetime')) {
      $(this).css('opacity', 0)
      $(this).css('pointer-events', 'none')
    }
  })

  function process(e) {
    // if (processing) {
      // e.preventDefault()
      // return
    // }
    // if ($refEl.data('limit')){
      // limit = $refEl.data('limit')
    // }
    // processing = true
    // $loadImage.fadeIn()
    // $moreBut.addClass('disabled')
    $allBut.css('opacity', 1)
    $allBut.css('pointer-events', 'auto')
    $updateClickers.addClass('disabled')
    var services = $('input[name="services"]')
    var refs = services.filter('[value="references"]').is(':checked') || undefined
    var studies = services.filter('[value="studies"]').is(':checked') || undefined

    console.log('ref', refs, 'stud', studies);

    var types = null
    // var showOnWhyUs = null
    // if ($refEl.data('onlypicked')){
    //   showOnWhyUs = true
    // }
    if ($filters.length) {
      types = []
      $filters.filter('.active').each(function() {
        types.push($(this).data('id'))
      })
    }
    // if (typeof ref === 'undefined') {
    //   ref = true
    // }
    // if (stud === undefined) {
    //   stud = true
    // }
    var params = {
      refs,
      studies,
      // limit,
      // skip,
      // publish: true,
      // showOnWhyUs: showOnWhyUs,
      categories: types
    }
    $.ajax({
      method: "GET",
      url: "/api/references",
      data: params,
      // context: document.body
    })
    .done(change)
    .fail(function(err) {
      // $loadImage.fadeOut()
      console.log('Error loading additional references.' + err.responseText)
    })
  }

  function change(data) {
    // console.log('test 0')

    $columns.each(function() {
      $(this).height($(this).height())
    })
    $noneFound.css('opacity', 0)
    if ($(data).find('.first').html().length === 1 &&
        $(data).find('.second').html().length === 1 &&
        $(data).find('.third').html().length === 1) {

          // console.log('test 1')
      $allBut.css('opacity', 0)
      $allBut.css('pointer-events', 'none')
      $.ajax({
        method: "GET",
        url: "/api/references",
        // context: document.body
      })
      .done(change)
      .fail(function(err) {
        // $loadImage.fadeOut()
        console.log('Error loading additional references.' + err.responseText)
      })
      .always(function() {
        $noneFound.css('opacity', 1)
      })
    }
    $columns.animate({
      opacity: 0
    }, 200, function() {
      // console.log('test 2')

      $ref1.html($(data).find('.first').html())
      $ref2.html($(data).find('.second').html())
      $ref3.html($(data).find('.third').html())
      $columns.css('height', 'auto')
      $updateClickers.removeClass('disabled')
      $columns.animate({
        opacity: 1
      }, 200)
      setTimeout(function() {
        // processing = false
        // $moreBut.removeClass('disabled')
      }, requestDelay)


      // novinka - preskladani referenci / sloupcu, podle delky
      const colItems1 = []
      const colItems2 = []
      const colItems3 = []

      $ref1.find('.content.item').each((index, item) => {
        colItems1.push({
          $item: $(item),
          height: $(item).height(),
        })
      })
      $ref2.find('.content.item').each((index, item) => {
        colItems2.push({
          $item: $(item),
          height: $(item).height(),
        })
      })
      $ref3.find('.content.item').each((index, item) => {
        colItems3.push({
          $item: $(item),
          height: $(item).height(),
        })
      })

      // clear all cols
      $ref1.html('')
      $ref2.html('')
      $ref3.html('')

      const allItems = []
      const maxLength = Math.max(colItems1.length, colItems2.length, colItems3.length)
      for (let index = 0; index < maxLength; index++) {
        let e = colItems1[index]
        if (e) {
          allItems.push(e)
        }
        e = colItems2[index]
        if (e) {
          allItems.push(e)
        }
        e = colItems3[index]
        if (e) {
          allItems.push(e)
        }
      }

      allItems.forEach(item => {
        if ($ref1.height() < $ref2.height() && $ref1.height() < $ref3.height()) {
          $ref1.append(item.$item)
        } else if ($ref2.height() < $ref3.height()) {
          $ref2.append(item.$item)
        } else {
          $ref3.append(item.$item)
        }
      })

      // $loadImage.fadeOut()
    })
    // limit = null
  }

  if (window.referencesPage) {
    change($('body').html())
  }
})()



// WEBPACK FOOTER //
// ./src/browser/oldJs/lib/references.js